import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { addToBagPoints } from '../../../actions/marketPlaceActions';
import { EcoPointsStarIcon, NextIcon } from '../../../assets/icons';
import { Translate } from '../../../language';
import MarketPlacehome from '../../../assets/img/Marketplace-morado.png';
import EcobolsaBlanco from '../../../img/EcobolsaBlanco.png';
import "./ShowCasePoints.css"
const ShowCasePoins = ({ consolidateProducts }) => {
    const dispatch = useDispatch()
    return (
        <div className='showCasePoins-container'>
            <div className='showCasePoins-title-container'>
                <div className='showCasePoins-icon-container'>
                    <img src={MarketPlacehome} height={30} />
                </div>
                <div className="showCasePoins-title">{Translate('MarketPlace', 'es')}</div>
                <div className="showCase-shoppingBag">
                    <Link className='link-style' to="/ShoppingBag/Points">{Translate('Ecobolsa', 'es')}</Link>
                    <div className='shop-icon-container'><img className='icon-style' src={EcobolsaBlanco} /></div>
                </div>
            </div>
            <div className='showCasePoins-subTitle'>EcoPuntos</div>
            <div className='content-producs-bar'>
                <NextIcon className="cls-back-next back-svg" height="25" width="25" />
                <div className='wrapper-5 column-gap row-gap mt-3 mk-products'>

                    {
                        consolidateProducts.map(( productId , index) => (
                           <div key={productId._id} className="mk_product_points" onClick={()=>dispatch(addToBagPoints(productId))}>
                               <EcoPointsStarIcon height={160}/>
                               <div className='mk_product_points_quantity'>{productId.pointsQuantity}</div>
                               <div className='mk_product_points_description'>EcoPuntos</div>
                           </div>
                        ))
                    }
                </div>
                <NextIcon className="cls-back-next" height="25" width="25" />
            </div>


        </div>
    )
};

export default ShowCasePoins;
